/**
   * Sets video playback speed
   * @param {React.RefObject<HTMLVideoElement>} videoRef - Reference to the video element
   * @param {number} speed - Playback speed (e.g., 2.0 for double speed)
   * @returns {void}
*/
export const setVideoSpeed = (videoRef: React.RefObject<HTMLVideoElement>, speed: number) => {
    if (!videoRef || !videoRef.current) return;
    
    // Set playback speed
    videoRef.current.playbackRate = speed;
};
    